import template from './ImageSlider.html';

/* @ngInject */
function imageSliderCtrl($scope, $interval) {
  const vm = this;

  /** * public variables ***/
  vm.index = 0;

  /** * private variables ***/
  const INTERVAL_TIME = 500;
  let interval = null;

  /** * public functions ***/
  vm.$postLink = postLink;
  vm.$onChanges = onChanges;
  vm.playSlides = playSlides;
  vm.nextSlide = nextSlide;
  vm.prevSlide = prevSlide;
  vm.stopPlaying = stopPlaying;

  function postLink() {
    $scope.$watch(() => vm.play, (newValue) => {
      vm.playSlides(newValue);
    });
  }

  function onChanges({ images }) {
    if (!images?.currentValue) { return }
    vm.images?.sort((a, b) => {
      const [aFile, bFile] = [a.sslUrl, b.sslUrl].map(url => (new URL(url)?.pathname || '').split('/').pop());
      return aFile.localeCompare(bFile);
    });
  }

  function playSlides(play) {
    if (play) {
      if (vm.images.length <= 1) {
        return;
      }
      if (interval) {
        $interval.cancel(interval);
      }
      interval = $interval(() => {
        nextSlide();
      }, INTERVAL_TIME);
    } else {
      if (interval) {
        $interval.cancel(interval);
      }
      vm.index = 0;
    }
  }

  function nextSlide() {
    vm.index = ++vm.index % vm.images.length;
  }

  function prevSlide() {
    $interval.cancel(interval);
    vm.index = --vm.index < 0 ? vm.images.length - 1 : vm.index;
  }

  function stopPlaying() {
    if (interval) {
      $interval.cancel(interval);
    }
  }
}

export default {
  name: 'imageSlider',
  template,
  controller: imageSliderCtrl,
  bindings: {
    images: '<',
    play: '<' // boolean, optional.  Control playing and stopping of slides from outside directive
  }
};
